import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, ShieldCheck, Heart } from 'lucide-react';
const benefits = [{
  icon: TrendingUp,
  title: 'Tax-Free Growth',
  description: 'Your indexed universal life cash value grows tax-deferred and can be accessed tax-free in retirement through properly structured policy loans.'
}, {
  icon: ShieldCheck,
  title: 'Market-Linked Returns, Zero Downside',
  description: 'Participate in market gains through index crediting strategies while your principal is protected from market losses with a 0% floor.'
}, {
  icon: Heart,
  title: 'Lifetime Protection',
  description: "Enjoy permanent life insurance coverage that protects your loved ones with a tax-free death benefit—no matter when it's needed."
}];
export function Benefits() {
  return <section id="benefits" className="py-20 md:py-28 bg-cream px-6" data-id="element-26">
      <div className="max-w-[1100px] mx-auto" data-id="element-27">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-28">
          <span className="text-copper font-bold text-sm tracking-wider uppercase mb-3 block" data-id="element-29">
            Benefits
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-30">
            Why Choose Indexed Universal Life Insurance?
          </h2>
          <p className="text-charcoal text-lg leading-relaxed" data-id="element-31">
            The right IUL policy can give you permanent protection,
            market-linked growth potential, and tax advantages that traditional
            retirement accounts simply can't match.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-32">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 hover:shadow-hover transition-shadow duration-300" data-id="element-33">
              <div className="w-12 h-12 bg-forest/5 rounded-full flex items-center justify-center mb-6 text-forest" data-id="element-34">
                <benefit.icon size={24} strokeWidth={1.5} data-id="element-35" />
              </div>
              <h3 className="text-xl font-bold text-forest mb-4" data-id="element-36">
                {benefit.title}
              </h3>
              <p className="text-charcoal/80 leading-relaxed" data-id="element-37">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}